import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup } from 'modules/theme';
import { globalAction } from 'store/action';
import { AuthBox, Links } from '../styles';
import APIManager from 'modules/common/apiManager';
import { apiUrl } from 'helpers/dotenv';
import { localStore } from 'helpers';
import { ControlLabel } from 'react-bootstrap';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';

const propTypes = {
  history: PropTypes.object
};

class adminLogin extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.tURL = apiUrl;

    let isLogin = true;
    let tUserID = localStorage.getItem('USER_ID');
    if (
      tUserID === null ||
      typeof tUserID === 'undefined' ||
      tUserID === 'undefined' ||
      tUserID === ''
    ) {
      isLogin = false;
    }

    this.state = {
      userID: '',
      email: '',
      password: '',
      loginForm: isLogin
    };

    this.login = this.login.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUserIDChange = this.handleUserIDChange.bind(this);
  }

  setForceParam(userId, url, isSecure = true) {
    let http = 'http://';
    let ws = 'ws://';
    if (isSecure) {
      http = 'https://';
      ws = 'wss://';
    }
    localStorage.setItem('USER_ID', userId);
    localStorage.setItem(
      'REACT_APP_API_SUBSCRIPTION_URL',
      `${ws}${url}/${userId}/api/`
    );
    localStorage.setItem('REACT_APP_API_URL', `${http}${url}/${userId}/api/`);
    localStorage.setItem(
      'CLOUD_APP_API_URL',
      'https://app.streamspace.ai/cloudManager'
    );
    localStorage.setItem(
      'REACT_FS_SERVER_HOST',
      `${http}${url}/${userId}/fs/api/play/`
    );
    localStorage.setItem('IS_CLOUD', false);
  }

  login(e) {
    e.preventDefault();
    const { email, password } = this.state;
    const { dynamicUpdate } = this.props;
    const user  = { 
      country_code: "",
      create_at: "2022-05-15T14:53:18.430Z",
      createdBy: "5854c4ae-1559-4487-909d-b093f3f8c106",
      email: "rahul.kumar@tubelightcommunications.com",
      isDeleted: false,
      isVerified: true,
      mobile_number: "8989757459",
      name: "Rahul",
      password: "$2b$10$q.XpmkXgCdULGVItZ82PHeDXyI.VdPTESbektKbC1sRr64DFiX2uG",
      phoneType: "web",
      role: 2,
      salt: "$2b$10$q.XpmkXgCdULGVItZ82PHe",
      sip: {_id: '555b7fb9-1db2-410c-a196-92240d216824', sip: 'rahul.kumar@tubelightcommunications.com', userName: 'iZfWF2LW', password: 'UwQPAen2', type: 'sip'},
      status: true,
      tags: (3) ['74982f4d-3ec4-4ca3-801c-4fc324dd31a1', '5758568d-3850-4241-9a51-d6e078719a6e', Array(0)],
      teams: (6) ['ebbbbc3a-bbf7-4441-9e77-2fa259f21569', '12589876-e239-46ae-9790-44bf54ff5144', 'cddc704b-90e5-4435-85db-e8f80366b550', '38db17a2-4428-4366-9165-0fd7ee51e1ed', '9ab4efb8-3d2e-4382-a69a-0ee9fad0a594', 'a3829a7b-f98c-4324-94c6-f9fc4a114147'],
      update_at: "2022-07-12T07:35:03.106Z",
      updatedBy: "6f4b2df6-30c2-4db4-a2ce-955d1f136e6e",
      userId: "6f4b2df6-30c2-4db4-a2ce-955d1f136e6e",
      user_name: "rahul",
      _id: "6f4b2df6-30c2-4db4-a2ce-955d1f136e6e"
}
let token = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbnVwYW0yIiwiaWF0IjoxNjU5NDM3MDU3LCJleHAiOjE3NDU4MzcwNTd9.pm1hF4eLD0OTp5AJUtVkAc_gJjgh-QD45m1PZCvX5A_vHjNopdxi3Pw3nYU5FjGm3RxBsJELQ4C67nrlIlV8oA";

    
    localStore.setItem('token', token);
    localStore.setItem('user', JSON.stringify(user));
    // this.props.history.push("/");
    window.location.href = '/dashboard';
    
    // this.mAPI.sendPostAPI(
    //   `auth/login`,
    //   {
    //     email: email,
    //     password: password
    //   },
    //   data => {
    //     let token = data.token;
    //     let user = data.user;
    //     console.log(`Setting UP user...`);
    //     try {
    //       console.log('hioiiiiii');
    //       localStore.setItem('token', token);
    //     } catch (e) {
    //       console.log('eeeee',e);
    //     }
    //     dynamicUpdate({ key: 'currentUser', value: user });
    //     // try {
    //     //   localStore.setItem('user', JSON.stringify(user));
    //     // } catch (e) {
    //     //   console.log(e);
    //     // }
    //     console.log(`organization --> reference updated`);
    //     this.props.history.push('/organization');
    //     // window.location.href = '/organization';
    //   },
    //   (error, data) => {
    //     console.log(`Error:`, error);
    //     this.setState({
    //       signInLoading: false
    //     });
    //     let message = data && data.message ? data.message : "Something went Wrong"; 
    //     Alert.error(message);
    //   },
    //   'public'
    // );
  }

  handleEmailChange(e) {
    e.preventDefault();
    this.setState({ email: e.target.value });
  }

  handleUserIDChange(e) {
    e.preventDefault();
    this.setState({ userID: e.target.value });
  }

  handlePasswordChange(e) {
    e.preventDefault();
    this.setState({ password: e.target.value });
  }

  renderLoginForm() {
    const { __ } = this.context;
    return (
      <div>
        {/* <h2 style={{ marginBottom: '20px' }}>{__('Login')}</h2> */}
        <p>{__('')}</p>
        <form onSubmit={this.login}>
          <FormGroup>
            <ControlLabel>Email</ControlLabel>
            <FormControl
              type="email"
              placeholder={__('your@email.com')}
              value={this.state.email}
              required
              onChange={this.handleEmailChange}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Password</ControlLabel>
            <FormControl
              type="password"
              placeholder={__('Password')}
              value={this.state.password}
              required
              onChange={this.handlePasswordChange}
            />
          </FormGroup>
          <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
            <Link to="/forgot-password">{__('I forgot my password')}</Link>
          </Links>
          {/* <div>
            <Button
              btnStyle="default"
              type="submit"
              block
              style={{ marginTop: '30px' }}
            >
              Login
            </Button>
            <Links style={{ marginTop: '15px', textAlign: 'center' }}>
              Don't have an account ?{' '}
              <Link to="/signup">{__('Register Now')}</Link>
            </Links>
          </div> */}
          <div>
            {/* <Button
              btnStyle="default"
              type="submit"
              // block
              style={{ marginTop: '30px', border: '1px solid #C7C7C7' }}
            >
              Sign In
            </Button> */}
            <Button
              btnStyle="default"
              type="submit"
              block
              style={{ marginTop: '30px' }}
            >
              Sign In
            </Button>
            <div className="line">
              <span> Or sign In with</span>
            </div>
            {/* <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
              <Link to="/otp">{__('Comfirm Email')}</Link>
            </Links> */}
          </div>
        </form>
        <Link style={{ color: '#000000' }} to="/tenant-signin">
          <Button
            btnStyle="simple"
            type="submit"
            block
            style={{
              marginTop: '30px',
              background: '#FAFAFA',
              border: '1px solid #EDE7F6'
            }}
          >
            {__('Tenant')}
          </Button>
        </Link>
      </div>
    );
  }

  render() {
    return <div style={{ width: '485px', margin: 'auto' }}><AuthBox>{this.renderLoginForm()}</AuthBox></div>;
  }
}

adminLogin.propTypes = propTypes;
adminLogin.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default withRouter(connect(stateToProps, dispatchToProps)(adminLogin));



// WEBPACK FOOTER //
// ./src/modules/auth/components/adminLogin.js